<template>
    <div class="after-sales-page">
        <!-- 顶部Header组件 -->
        <Header />

        <!-- 主体内容区域 -->
        <main class="content-wrapper">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/buyer' }">我的订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                    <el-breadcrumb-item>申请售后</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 售后申请表单区域 -->
            <div class="after-sales-container">
                <!-- 商品信息 -->
                <div class="goods-info">
                    <div class="goods-image">
                        <img :src="goodsInfo.goods_thumb || ''" alt="商品图片" />
                    </div>
                    <div class="goods-details">
                        <div class="goods-name">{{ goodsInfo.goods_name }}</div>
                        <div class="goods-spec">{{ goodsInfo.sku_name }} {{ goodsInfo.shop_price }}/{{ goodsInfo.unit ||
                            '' }}
                        </div>
                        <!-- <div class="goods-price">{{ goodsInfo.shop_price }}</div> -->
                    </div>
                </div>

                <!-- 售后申请表单 -->
                <div class="after-sales-form">
                    <!-- 售后选择 -->
                    <div class="form-item">
                        <label class="form-label">售后选择：</label>
                        <div class="radio-group">
                            <el-radio v-model="afterSalesForm.type" label="1">退款（无需退货）</el-radio>
                            <el-radio v-model="afterSalesForm.type" label="2">退货退款</el-radio>
                        </div>
                    </div>

                    <!-- 退款原因 -->
                    <div class="form-item">
                        <label class="form-label">退款原因：</label>
                        <div class="select-wrapper">
                            <el-select v-model="afterSalesForm.reason" placeholder="请选择" class="reason-select">
                                <el-option v-for="item in refundReasons" :key="item.aid" :label="item.reason"
                                    :value="item.aid" />
                            </el-select>
                        </div>
                    </div>

                    <!-- 退款金额 -->
                    <div class="form-item">
                        <label class="form-label">退款金额：</label>
                        <div class="amount-display">
                            <span class="amount-symbol">¥</span>
                            <span class="amount-value">{{ afterSalesForm.amount }}</span>
                        </div>
                    </div>

                    <!-- 退款说明 -->
                    <div class="form-item">
                        <label class="form-label">退款说明：</label>
                        <div class="textarea-wrapper">
                            <el-input v-model="afterSalesForm.description" type="textarea" :rows="4"
                                placeholder="请填写退款说明" class="description-textarea" />
                        </div>
                    </div>

                    <!-- 上传凭证 -->
                    <div class="form-item">
                        <label class="form-label">上传凭证：</label>
                        <div class="upload-wrapper">
                            <ImageUpload :image-url="afterSalesForm.thumb" :max-files="9"
                                @upload-success="handleImgUpload(2, $event)" />
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="预览图片" />
                            </el-dialog>
                        </div>
                    </div>

                    <!-- 提交按钮 -->
                    <div class="form-item form-actions">
                        <el-button type="primary" @click="submitAfterSales" class="submit-btn">提交</el-button>
                    </div>
                </div>
            </div>
        </main>

        <!-- 底部Footer组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
    name: 'ShenqingShouhou',
    components: {
        Header,
        Footer,
        ImageUpload

    },
    data() {
        return {
            // 默认商品图片
            defaultGoodsImage: '../../assets/images/default-goods.png',

            // 商品信息
            goodsInfo: {},

            // 售后申请表单数据
            afterSalesForm: {
                type: '1', // 1: 退款(无需退货), 2: 退货退款
                reason: '', // 退款原因
                amount: '0', // 退款金额
                description: '', // 退款说明
                thumb: [] // 上传的凭证图片
            },

            // 图片预览对话框
            dialogImageUrl: '',
            dialogVisible: false,

            refundReasons: [],
            dataMoney: ''
        }
    },
    created() {
        // 可以在这里获取商品信息和初始化表单数据
        this.getRefundGoodsDetail()
        this.getRefundReasons()
    },
    methods: {

        // 处理图片上传成功事件
        handleImgUpload(type, imageUrl) {
            if (type === 1) {
                this.afterSalesForm.thumb = imageUrl[0];
            } else if (type === 2) {
                this.afterSalesForm.thumb = imageUrl;
            } else if (type === 3) {
                this.afterSalesForm.product_certificate = imageUrl[0];
            }
        },


        // 获取售后商品详情
        getRefundGoodsDetail() {
            // 实际项目中这里应该调用API获取售后商品详情
            this.$api.getRefundGoodsDetail({
                order_goods_id: this.$route.query.orderId
            }).then(res => {
                this.goodsInfo = res
                this.num = this.goodsInfo.num
                this.getRefundPrice()
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取退款金额
        getRefundPrice() {
            // 实际项目中这里应该调用API获取售后商品详情
            this.$api.getRefundPrice({
                order_goods_id: this.$route.query.orderId,
                num: this.num
            }).then(res => {
                this.afterSalesForm.amount = res.refund_money
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取售后原因列表
        getRefundReasons() {
            // 实际项目中这里应该调用API获取售后原因列表
            this.$api.getRefundReasons({
                type: '1',
                list_rows: '999',
                goods_type: this.$route.query.orderId
            }).then(res => {
                this.refundReasons = res
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 图片预览
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },

        // 删除图片
        handleRemove(file, fileList) {
            this.afterSalesForm.images = fileList
        },

        // 提交售后申请
        submitAfterSales() {
            // 表单验证
            if (!this.afterSalesForm.reason) {
                this.$message.warning('请选择退款原因')
                return
            }

            if (!this.afterSalesForm.description.trim()) {
                this.$message.warning('请填写退款说明')
                return
            }

            let data = {
                order_id: this.goodsInfo.order_id,
                goods_id: this.goodsInfo.goods_id,
                sku_id: this.goodsInfo.sku_id,
                num: this.num,
                refund_type: this.afterSalesForm.type,
                refund_reason: this.afterSalesForm.reason,
                refund_picture: this.afterSalesForm.thumb,
                refund_content: this.afterSalesForm.description
            }
            // 实际项目中这里应该调用API提交售后申请
            console.log('提交售后申请:', data)
            // return
            this.$dapi.submitRefund(data).then(res => {
                this.$message.success('售后申请提交成功！')
                // 提交成功后跳转
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1500)
            }).catch(err => {
                this.$message.error(err);
            })

        }
    }
}
</script>

<style scoped>
.after-sales-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
}

.content-wrapper {
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
}

.after-sales-container {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 1200px;
    margin: 0 auto;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.goods-image {
    width: 80px;
    height: 80px;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 15px;
}

.goods-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.goods-details {
    flex: 1;
}

.goods-name {
    display: flex;
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
}

.goods-spec {
    display: flex;
    font-size: 12px;
    color: #999;
    margin-bottom: 5px;
}

.goods-price {
    font-size: 14px;
    color: #ff4d4f;
}

/* 售后表单样式 */
.after-sales-form {
    padding: 0 10px;
}

.form-item {
    margin-bottom: 25px;
    display: flex;
    align-items: flex-start;
}

.form-label {
    font-size: 14px;
    color: #333;
    width: 100px;
    text-align: right;
    margin-right: 20px;
    /* margin-top: 8px; */
    flex-shrink: 0;
}

/* 售后选择样式 */
.radio-group {
    display: flex;
    align-items: center;
}

.radio-group .el-radio {
    margin-right: 30px;
}

/* 选择框样式 */
.select-wrapper {
    flex: 1;
    max-width: 300px;
}

.reason-select {
    width: 100%;
}

/* 金额显示样式 */
.amount-display {
    display: flex;
    align-items: center;
    color: #ff4d4f;
    font-size: 16px;
    margin-top: 8px;
}

.amount-symbol {
    margin-right: 2px;
}

.amount-value {
    font-weight: 500;
}

/* 文本域样式 */
.textarea-wrapper {
    flex: 1;
    max-width: 500px;
}

.description-textarea {
    width: 100%;
}

/* 上传凭证样式 */
.upload-wrapper {
    flex: 1;
    max-width: 500px;
}

.evidence-upload .el-upload--picture-card {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px dashed #d9d9d9;
}

.evidence-upload .el-upload--picture-card i {
    font-size: 24px;
    color: #999;
}

/* 提交按钮样式 */
.form-actions {
    justify-content: center;
    margin-top: 40px;
}

.submit-btn {
    width: 120px;
    height: 40px;
    font-size: 16px;
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
}

.submit-btn:hover {
    background-color: #1c5cd8;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .content-wrapper {
        width: 100%;
        padding: 10px;
    }

    .after-sales-container {
        padding: 15px;
    }

    .form-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .form-label {
        text-align: left;
        margin-right: 0;
        margin-bottom: 10px;
    }

    .select-wrapper,
    .textarea-wrapper,
    .upload-wrapper {
        max-width: 100%;
    }
}
</style>